export function textWriter(textRef) {
	if (!textRef) return;

	const originalText = textRef.textContent ?? '';
	if (!originalText.trim()) return;

	const oldSpan = textRef.querySelector('span');
	if (oldSpan) oldSpan.remove();

	const span = document.createElement('span');
	textRef.innerHTML = '';
	textRef.appendChild(span);

	let i = 0;

	let typingInterval = setInterval(() => {
		if (i < originalText.length) {
			span.textContent += originalText[i++];
		} else {
			clearInterval(typingInterval);
		}
	}, 100);
}
